import React from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardHeader, MDBCardBody } from 'mdb-react-ui-kit'
import PaymentMethods from './components/PaymentMethods/PaymentMethods.component'
import SubscriptionPackage from './components/SubscriptionPackage/SubscriptionPackage.component'
import UserProfileService from './../../shared/services/UserProfile.service'
import AgentPackages from './../../components/shared/AgentPackages.component'
import BeastModeAccountLink from './components/BeastModeAccountLink/BeastModeAccountLink.component'
import EditDowngradeContentButtons from './components/EditDowngradeContentButtons/EditDowngradeContentButtons.component'
import SubscriptionsStore from './Subscriptions.store'

import './AccountBillingInfo.scss'

class AccountBillingInfoPage extends React.Component {
  state = {
    blocked: false,
  }

  setUser = async () => {
    if (parseInt(SubscriptionsStore.User && SubscriptionsStore.User?.id()) !== parseInt(UserProfileService.getUserId()))
      SubscriptionsStore.initUser(await UserProfileService.instance())
  }

  componentDidMount() {
    if (parseInt(UserProfileService?.get('can_upgrade_signature')) === 1) {
      this.setState({ blocked: true })
      return
    }

    this.setUser()
  }

  componentDidUpdate() {
    this.setUser()
  }

  render() {
    if (this.state.blocked) {
      return (
        <DashboardLayout>
          <main id='AccountBillingInfoPage' className='mainSection mt-5 pb-5'>
            <MDBContainer>
              <MDBRow>
                <MDBCol>
                  <h4 className='text-danger'>Access to Billing Info is restricted.</h4>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </main>
        </DashboardLayout>
      )
    }

    return (
      <DashboardLayout>
        <main id='AccountBillingInfoPage' className='mainSection mt-5 pb-5'>
          <MDBContainer fluid>
            <MDBRow>
              <MDBCol size='12' sm='6'>
                <h2>Billing Info</h2>
              </MDBCol>
              <MDBCol size='12' sm='6'>
                <EditDowngradeContentButtons />
              </MDBCol>
              <MDBCol>
                <hr />
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol size='12'>
                <MDBCard className='agent-packages-card'>
                  <MDBCardHeader>Agent Packages</MDBCardHeader>
                  <MDBCardBody>
                    <AgentPackages />
                  </MDBCardBody>
                </MDBCard>
                <br />
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol size='12' md='6'>
                <SubscriptionPackage />
              </MDBCol>

              <MDBCol size='12' md='6'>
                <PaymentMethods />
                <br />
                <BeastModeAccountLink userId={UserProfileService.getUserId()} />
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </main>
      </DashboardLayout>
    )
  }
}

export default AccountBillingInfoPage
